import { render, staticRenderFns } from "./RecommendUserForProjectsMobileLayer.vue?vue&type=template&id=344b39ee&scoped=true"
import script from "./RecommendUserForProjectsMobileLayer.vue?vue&type=script&lang=ts"
export * from "./RecommendUserForProjectsMobileLayer.vue?vue&type=script&lang=ts"
import style0 from "./RecommendUserForProjectsMobileLayer.vue?vue&type=style&index=0&id=344b39ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344b39ee",
  null
  
)

export default component.exports